import { useEffect } from "react";
import { useAuth } from "../lib/AuthContext";

// La page "Gestion" redirige vers l'app HTML standalone /gestion.html
// qui fonctionne de façon autonome et utilise l'auth cookie pour savoir qui est connecté.
export default function Gestion() {
  const { user, org } = useAuth();

  useEffect(() => {
    // Injecte l'info user dans gestion.html via sessionStorage (l'iframe y a accès si même origine)
    sessionStorage.setItem("lagon_auth", JSON.stringify({ user, org }));
  }, [user, org]);

  return (
    <div style={{position:'relative', height:'calc(100vh - 68px)', width:'100%'}}>
      <iframe
        src="/gestion.html"
        title="Gestion commerciale"
        style={{border:'none', width:'100%', height:'100%', display:'block'}}
        data-testid="gestion-iframe"
      />
    </div>
  );
}
